// src/components/Control/Operator/Toasts.tsx
// Всплывающие уведомления (тревоги няни и зрения, ошибки, подтверждение STOP).
import React from 'react';
import { useEventsState, useRobot } from '../robot/RobotContext';
import { dismissToast, SOURCE_NAMES } from '../robot/events';
import { Icon } from './ui';

const LEVEL_MARK: Record<string, string> = { info: 'ℹ', ok: '✓', warn: '▲', alert: '!', error: '■' };

const Toasts: React.FC = () => {
  const { events } = useRobot();
  const toasts = useEventsState(e => e.toasts);
  return (
    <div className="op-toasts" aria-live="polite" aria-atomic="false">
      {toasts.map(t => (
        <div key={t.id} className={`op-toast ${t.level}`} role={t.level === 'alert' || t.level === 'error' ? 'alert' : 'status'}>
          <span className="op-toast-mark" aria-hidden="true">{LEVEL_MARK[t.level]}</span>
          <span className="op-toast-text">
            <small>{SOURCE_NAMES[t.source]}</small>
            {t.text}
          </span>
          <button type="button" className="op-icon-btn small" aria-label="Закрыть уведомление" onClick={() => dismissToast(events, t.id)}>
            <Icon name="close" size={14} />
          </button>
        </div>
      ))}
    </div>
  );
};

export default Toasts;
